(() => {
  function init() {
    const splide = new Splide(".section-info-slider--wrapper .splide", {
      type: "loop",
      drag: false,
      focus: "center",
      autoWidth: true,
      gap: 16,
      arrows: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      pagination: false,
      autoScroll: {
        speed: 0.6,
      },
    });
    splide.mount(window.splide.Extensions);
  }
  document.addEventListener("DOMContentLoaded", init);
})();
